/* eslint-disable no-bitwise */

/**
 * Created by 白 on 2015/2/16.
 * 计算农历
 * 非原创,修改https://github.com/6tail/lunar-javascript
 */
import { addDate } from './date';
var BASE_YEAR = 1901;
var BASE_MONTH = 1;
var BASE_DAY = 1;
var LUNAR_BASE_YEAR = 1900;
var LUNAR_BASE_MONTH = 11;
var LUNAR_BASE_DAY = 11;
var LUNAR_BASE_INDEX = 0;
var LUNAR_LEAP_MONTH_YEAR = [6, 14, 19, 25, 33, 36, 38, 41, 44, 52, 55, 79, 117, 136, 147, 150, 155, 158, 185, 193];
var LUNAR_MONTH = [0x00, 0x04, 0xad, 0x08, 0x5a, 0x01, 0xd5, 0x54, 0xb4, 0x09, 0x64, 0x05, 0x59, 0x45, 0x95, 0x0a, 0xa6, 0x04, 0x55, 0x24, 0xad, 0x08, 0x5a, 0x62, 0xda, 0x04, 0xb4, 0x05, 0xb4, 0x55, 0x52, 0x0d, 0x94, 0x0a, 0x4a, 0x2a, 0x56, 0x02, 0x6d, 0x71, 0x6d, 0x01, 0xda, 0x02, 0xd2, 0x52, 0xa9, 0x05, 0x49, 0x0d, 0x2a, 0x45, 0x2b, 0x09, 0x56, 0x01, 0xb5, 0x20, 0x6d, 0x01, 0x59, 0x69, 0xd4, 0x0a, 0xa8, 0x05, 0xa9, 0x56, 0xa5, 0x04, 0x2b, 0x09, 0x9e, 0x38, 0xb6, 0x08, 0xec, 0x74, 0x6c, 0x05, 0xd4, 0x0a, 0xe4, 0x6a, 0x52, 0x05, 0x95, 0x0a, 0x5a, 0x42, 0x5b, 0x04, 0xb6, 0x04, 0xb4, 0x22, 0x6a, 0x05, 0x52, 0x75, 0xc9, 0x0a, 0x52, 0x05, 0x35, 0x55, 0x4d, 0x0a, 0x5a, 0x02, 0x5d, 0x31, 0xb5, 0x02, 0x6a, 0x8a, 0x68, 0x05, 0xa9, 0x0a, 0x8a, 0x6a, 0x2a, 0x05, 0x2d, 0x09, 0xaa, 0x48, 0x5a, 0x01, 0xb5, 0x09, 0xb0, 0x39, 0x64, 0x05, 0x25, 0x75, 0x95, 0x0a, 0x96, 0x04, 0x4d, 0x54, 0xad, 0x04, 0xda, 0x04, 0xd4, 0x44, 0xb4, 0x05, 0x54, 0x85, 0x52, 0x0d, 0x92, 0x0a, 0x56, 0x6a, 0x56, 0x02, 0x6d, 0x02, 0x6a, 0x41, 0xda, 0x02, 0xb2, 0xa1, 0xa9, 0x05, 0x49, 0x0d, 0x0a, 0x6d, 0x2a, 0x09, 0x56, 0x01, 0xad, 0x50, 0x6d, 0x01, 0xd9, 0x02, 0xd1, 0x3a, 0xa8, 0x05, 0x29, 0x85, 0xa5, 0x0c, 0x2a, 0x09, 0x96, 0x54, 0xb6, 0x08, 0x6c, 0x09, 0x64, 0x45, 0xd4, 0x0a, 0xa4, 0x05, 0x51, 0x25, 0x95, 0x0a, 0x2a, 0x72, 0x5b, 0x04, 0xb6, 0x04, 0xac, 0x52, 0x6a, 0x05, 0xd2, 0x0a, 0xa2, 0x4a, 0x4a, 0x05, 0x55, 0x94, 0x2d, 0x0a, 0x5a, 0x02, 0x75, 0x61, 0xb5, 0x02, 0x6a, 0x03, 0x61, 0x45, 0xa9, 0x0a, 0x4a, 0x05, 0x25, 0x25, 0x2d, 0x09, 0x9a, 0x68, 0xda, 0x08, 0xb4, 0x09, 0xa8, 0x59, 0x54, 0x03, 0xa5, 0x0a, 0x91, 0x3a, 0x96, 0x04, 0xad, 0xb0, 0xad, 0x04, 0xda, 0x04, 0xf4, 0x62, 0xb4, 0x05, 0x54, 0x0b, 0x44, 0x5d, 0x52, 0x0a, 0x95, 0x04, 0x55, 0x22, 0x6d, 0x02, 0x5a, 0x71, 0xda, 0x02, 0xaa, 0x05, 0xb2, 0x55, 0x49, 0x0b, 0x4a, 0x0a, 0x2d, 0x39, 0x36, 0x01, 0x6d, 0x80, 0x6d, 0x01, 0xd9, 0x02, 0xe9, 0x6a, 0xa8, 0x05, 0x29, 0x0b, 0x9a, 0x4c, 0xaa, 0x08, 0xb6, 0x08, 0xb4, 0x38, 0x6c, 0x09, 0x54, 0x75, 0xd4, 0x0a, 0xa4, 0x05, 0x45, 0x55, 0x95, 0x0a, 0x9a, 0x04, 0x55, 0x44, 0xb5, 0x04, 0x6a, 0x82, 0x6a, 0x05, 0xd2, 0x0a, 0x92, 0x6a, 0x4a, 0x05, 0x55, 0x0a, 0x2a, 0x4a, 0x5a, 0x02, 0xb5, 0x02, 0xb2, 0x31, 0x69, 0x03, 0x31, 0x73, 0xa9, 0x0a, 0x4a, 0x05, 0x2d, 0x55, 0x2d, 0x09, 0x5a, 0x01, 0xd5, 0x48, 0xb4, 0x09, 0x68, 0x89, 0x54, 0x0b, 0xa4, 0x0a, 0xa5, 0x6a, 0x95, 0x04, 0xad, 0x08, 0x6a, 0x44, 0xda, 0x04, 0x74, 0x05, 0xb0, 0x25, 0x54, 0x03];

function daysInMonth(year, month) {
  return new Date(year, month, 0).getDate();
}

function isLeapYear(year) {
  var leap = false;
  if (year % 4 === 0) leap = true;
  if (year % 100 === 0) leap = false;
  if (year % 400 === 0) leap = true;
  return leap;
}

function getLunarLeapMonth(year) {
  var index = year - LUNAR_BASE_YEAR + LUNAR_BASE_INDEX;
  var v = LUNAR_MONTH[2 * index + 1];
  v = v >> 4 & 0x0f;
  return v;
}

function nextLunarMonth(y, m) {
  var n = Math.abs(m) + 1;

  if (m > 0) {
    if (m === getLunarLeapMonth(y)) {
      n = -m;
    }
  }

  return n !== 13 ? n : 1;
}

function getLunarDaysOfMonth(year, month) {
  var index = year - LUNAR_BASE_YEAR + LUNAR_BASE_INDEX;
  var v = 0;
  var l = 0;
  var d = 30;

  if (month >= 1 && month <= 8) {
    v = LUNAR_MONTH[2 * index];
    l = month - 1;

    if ((v >> l & 0x01) === 1) {
      d = 29;
    }
  } else if (month >= 9 && month <= 12) {
    v = LUNAR_MONTH[2 * index + 1];
    l = month - 9;

    if ((v >> l & 0x01) === 1) {
      d = 29;
    }
  } else {
    v = LUNAR_MONTH[2 * index + 1];
    v = v >> 4 & 0x0f;

    if (v !== Math.abs(month)) {
      d = 0;
    } else {
      d = 29;

      for (var i = 0; i < LUNAR_LEAP_MONTH_YEAR.length; i++) {
        if (LUNAR_LEAP_MONTH_YEAR[i] === index) {
          d = 30;
          break;
        }
      }
    }
  }

  return d;
}

export function Lunar(date) {
  var y = date.getFullYear();
  var m = date.getMonth() + 1;
  var d = date.getDate();
  var startY, startM, startD;
  var year, month, day;

  if (y < 2000) {
    startY = BASE_YEAR;
    startM = BASE_MONTH;
    startD = BASE_DAY;
    year = LUNAR_BASE_YEAR;
    month = LUNAR_BASE_MONTH;
    day = LUNAR_BASE_DAY;
  } else {
    startY = BASE_YEAR + 99;
    startM = 1;
    startD = 1;
    year = LUNAR_BASE_YEAR + 99;
    month = 11;
    day = 25;
  }

  var diff = 0,
      i;

  for (i = startY; i < y; i++) {
    diff += 365;
    if (isLeapYear(i)) diff += 1;
  }

  for (i = startM; i < m; i++) {
    diff += daysInMonth(y, i);
  }

  diff += d - startD;
  day += diff;
  var lastDate = getLunarDaysOfMonth(year, month);

  while (day > lastDate) {
    day -= lastDate;
    month = nextLunarMonth(year, month);
    if (month === 1) year++;
    lastDate = getLunarDaysOfMonth(year, month);
  }

  return {
    year: year,
    month: Math.abs(month),
    day: day,
    isLeap: month < 0
  };
} // 判断是否是除夕

export function isNewYearEve(date) {
  // 如果第二天是非闰月大年初一，则是除夕
  var _Lunar = Lunar(addDate(date, 1, 'day')),
      month = _Lunar.month,
      day = _Lunar.day,
      isLeap = _Lunar.isLeap;

  return month === 1 && day === 1 && !isLeap;
}
var months = ['正', '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一', '腊'];
var days = ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十'];
export function getMonthChn(index) {
  return "".concat(months[index - 1], "\u6708");
}
export function getDayChn(index) {
  var day = days[(index - 1) % 10];

  if (index <= 10) {
    return "\u521D".concat(day);
  }

  if (index < 20) {
    return "\u5341".concat(day);
  }

  if (index === 20) {
    return '二十';
  }

  if (index < 30) {
    return "\u5EFF".concat(day);
  }

  if (index === 30) {
    return '三十';
  }

  return '';
}
export function toString(_ref) {
  var month = _ref.month,
      day = _ref.day;
  return "".concat(getMonthChn(month)).concat(getDayChn(day));
}
export function Solar(_ref2) {
  var y = _ref2.year,
      m = _ref2.month,
      d = _ref2.day,
      isLeap = _ref2.isLeap;
  if (isLeap) m = -m;
  var startY, startM;
  var year, month, day;

  if (y < 2000) {
    startY = BASE_YEAR;
    startM = BASE_MONTH;
    year = LUNAR_BASE_YEAR;
    month = LUNAR_BASE_MONTH;
    day = LUNAR_BASE_DAY;
  } else {
    startY = BASE_YEAR + 99;
    startM = 1;
    year = LUNAR_BASE_YEAR + 99;
    month = 11;
    day = 25;
  }

  var diff = 0;
  var lastDate = 0;
  diff = getLunarDaysOfMonth(year, month) - day;

  while (year !== y || month !== m) {
    diff += lastDate;
    month = nextLunarMonth(year, month);
    if (month === 1) year++;
    lastDate = getLunarDaysOfMonth(year, month);
  }

  diff += d;

  while (diff >= 365) {
    diff -= 365;
    if (isLeapYear(startY)) diff -= 1;
    startY += 1;
  }

  while (diff >= daysInMonth(y, startM)) {
    diff -= daysInMonth(y, startM);
    startM += 1;
  }

  return new Date(startY, startM - 1, diff + 1);
} // 除夕直接返回前一年的除夕
// 比如今年五月有三十、去年五月只有二十九，那么三十要对到二十九
// 前一年没有闰月 或者 传入月份在前一年不是闰月  或者 传入月份前一年是闰月但不是腊月  直接返回 非闰
// 传入月份前一年是闰月 且是 腊月  直接返回 闰

export function getYOY(date) {
  var _Lunar2 = Lunar(date),
      year = _Lunar2.year,
      month = _Lunar2.month,
      day = _Lunar2.day;

  var lastYear = year - 1; // 去年

  var lastYearLeap = getLunarLeapMonth(lastYear); // 去年闰月的月份
  // 除夕同比

  if (isNewYearEve(date)) {
    var _isLeap = lastYearLeap === 12;

    return Solar({
      year: lastYear,
      month: month,
      day: getLunarDaysOfMonth(lastYear, _isLeap ? -12 : 12),
      isLeap: _isLeap
    });
  } // 仅当对比月份是闰月且是12月时，对比到闰月


  var isLeap = lastYearLeap === month && month === 12;
  return Solar({
    year: lastYear,
    month: month,
    day: Math.min(day, getLunarDaysOfMonth(lastYear, isLeap ? -month : month)),
    isLeap: isLeap
  });
}
export var findYOY = function findYOY(d) {
  var nd = getYOY(d);
  return new Date(nd.getFullYear(), nd.getMonth(), nd.getDate(), d.getHours(), d.getMinutes(), d.getSeconds(), d.getMilliseconds());
};